module.exports = __webpack_public_path__ + "img/DE05789.ef121cdb.png";